














import { Component, Prop, Vue } from 'vue-property-decorator'
import AppLink from '@/components/sidebar/Link.vue'
import Item from '@/components/sidebar/MenuItem.vue'
import { RouteConfig } from 'vue-router'
import path from 'path'

@Component({ components: { Item, AppLink } })
export default class SidebarItem extends Vue {
  @Prop({ required: true }) item!: RouteConfig
  @Prop({ default: false }) isNest!: boolean
  @Prop({ default: '' }) basePath!: string

  get menuIndex(): string {
    let menuIndex = this.resolvePath(this.item.path)

    if (this.item.children) {
      this.item.children.forEach(child => {
        if (child.name === this.$route.name) {
          menuIndex = this.$route.path
        }
      })
    }

    return menuIndex
  }

  resolvePath(routePath: string): string {
    if (this.isExternalLink(routePath)) {
      return routePath
    }

    return path.resolve(this.basePath, routePath)
  }

  isExternalLink(routePath: string): boolean {
    return /^(https?:|mailto:|tel:)/.test(routePath)
  }
}
